import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    rootGrid: {
        flexGrow: 1,
    },
	titleGrid: {
		backgroundColor:'gainsboro',
	},
	typographyTitle: {
		margin: '0px',
		fontSize: '15px',
	},
	typography: {
		margin: '0px',
		fontSize: '14px',
	},
  }));